import React, { useState, useEffect } from 'react';
import { Upload } from 'antd';

import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;


export default function UploadItem(props) {

    const { onChange } = props;

    const [files, setFiles] = useState([]);

    // console.log("UploadItem props.value", value);
    useEffect(() => {
        // const formData = new FormData();
        // files.forEach(file => {
        //     console.log(file);
        //     formData.append('files[]', file);
        // });
        // triggerChange(formData);
        triggerChange(files);
    }, [files]);

    const triggerChange = (changedValue) => {
        if (onChange) {
            onChange([
                ...changedValue,
            ]);
        }
    };

    const uploadingProps = {
        maxCount: 1,
        name: 'file',
        multiple: false,
        onRemove: file => {
            const index = files.indexOf(file);
            const newFiles = files.slice();
            newFiles.splice(index, 1);
            setFiles(newFiles);
        },
        beforeUpload: file => {
            if (props.multiple) {
                setFiles([...files, file]);
            } else {
                setFiles([file]);
            }
            return false;
        },
        fileList: files,
    };
    return (
        <Dragger {...uploadingProps}>
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">Нажмите для выбора или перетащите файл <br />в выделенную область</p>
            <p className="ant-upload-hint">
                Поддерживается загрузка любых типов файлов
        </p>
        </Dragger>
    );
}